import { AnimatePresence } from 'motion/react'
import { useState } from 'react'
import styled from 'styled-components'

import { ManageHiddenAssetsDialog } from '@root/features/wallet/assets-management/ui/desktop'
import { useTranslation } from '@root/shared/localization'
import { DataTableHeaderCell, EyeClosedIcon } from '@root/shared/ui-kit'

import type {
  WalletAssetsColumnId,
  WalletAssetsTableContext,
} from '../../atoms/reatom-wallet-assets-table'
import type { WalletAssetModel } from '@root/entities/wallet'
import type { ColumnHeaderRenderProps } from '@root/shared/ui-kit'

type Props = ColumnHeaderRenderProps<
  WalletAssetModel,
  WalletAssetsColumnId,
  WalletAssetsTableContext
>

export const WalletAssetsTableBalanceHeader: React.FC<Props> = ({
  ...props
}) => {
  const { t } = useTranslation()
  const { wallet } = props.context
  const [open, setOpen] = useState(false)

  return (
    <Root>
      <DataTableHeaderCell {...props} />
      <ManageButton onClick={() => setOpen(true)}>
        <EyeClosedIcon size={12} />
        <span>{t('wallet-manager.hidden-assets')}</span>
      </ManageButton>
      {/* necessary to reset state */}
      <AnimatePresence>
        {open ? (
          <ManageHiddenAssetsDialog
            open={open}
            onOpenChange={setOpen}
            wallet={wallet}
          />
        ) : undefined}
      </AnimatePresence>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-auto-flow: column;
`

const ManageButton = styled.div`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: color 0.15s ease-in-out;

  &:hover {
    color: var(--text-10);
  }

  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 4px;
`
